import { render, staticRenderFns } from "./UserTypes.vue?vue&type=template&id=e1a6fd50&scoped=true"
import script from "./UserTypes.vue?vue&type=script&lang=js"
export * from "./UserTypes.vue?vue&type=script&lang=js"
import style0 from "./UserTypes.vue?vue&type=style&index=0&id=e1a6fd50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1a6fd50",
  null
  
)

export default component.exports